export default __webpack_public_path__ + "bc8486ba57dbfd27b9d9a61d8d6344ae.png";